// Releases pre-generated enemies as the wave clock advances, and spawns this
// wave's flyer (bomber/satellite) at its scheduled time. The wave clock
// (waveTimer) is advanced here.

import type { EnemyMissile, FlyingObject, SpawnEntry } from '../state/types';
import type { ReleaseSpawns, SpawnFlying } from './contracts';
import { direction, scale } from '../geometry/vec2';
import { intInRange } from '../rng/mulberry32';
import { waveConfig } from '../waves/waveConfig';
import {
  BOMBER_Y,
  FIELD_W,
  FIXED_DT,
  FLYING_DROP_INTERVAL,
  FLYING_SPEED,
  SATELLITE_Y,
} from '../constants';

export const releaseSpawns: ReleaseSpawns = (state) => {
  if (state.phase.kind !== 'playing') return state;
  const waveTimer = state.waveTimer + FIXED_DT;
  if (state.spawnQueue.length === 0) return { ...state, waveTimer };

  const speed = waveConfig(state.wave).speed;
  let nextId = state.nextEntityId;
  const remaining: SpawnEntry[] = [];
  const released: EnemyMissile[] = [];

  for (const entry of state.spawnQueue) {
    if (entry.releaseAt <= waveTimer) {
      released.push({
        id: nextId++,
        kind: entry.kind,
        origin: entry.origin,
        pos: entry.origin,
        target: entry.target,
        vel: scale(direction(entry.origin, entry.target), speed),
        splitAt: entry.splitAt,
      });
    } else {
      remaining.push(entry);
    }
  }

  if (released.length === 0) return { ...state, waveTimer };
  return {
    ...state,
    waveTimer,
    spawnQueue: remaining,
    enemyMissiles: [...state.enemyMissiles, ...released],
    nextEntityId: nextId,
  };
};

export const spawnFlying: SpawnFlying = (state) => {
  if (state.phase.kind !== 'playing') return state;
  if (state.flyingSpawnAt === null || state.waveTimer < state.flyingSpawnAt) {
    return state;
  }

  const kindDraw = intInRange(state.rng, 0, 2);
  const dirDraw = intInRange(kindDraw.state, 0, 2);
  const kind: FlyingObject['kind'] = kindDraw.value === 0 ? 'bomber' : 'satellite';
  const fromLeft = dirDraw.value === 0;
  const y = kind === 'bomber' ? BOMBER_Y : SATELLITE_Y;

  const flyer: FlyingObject = {
    id: state.nextEntityId,
    kind,
    pos: { x: fromLeft ? -20 : FIELD_W + 20, y },
    vel: { x: fromLeft ? FLYING_SPEED : -FLYING_SPEED, y: 0 },
    dropCooldown: FLYING_DROP_INTERVAL,
  };

  return {
    ...state,
    flyingObjects: [...state.flyingObjects, flyer],
    flyingSpawnAt: null,
    rng: dirDraw.state,
    nextEntityId: state.nextEntityId + 1,
  };
};
